import { render, staticRenderFns } from "./reportList.vue?vue&type=template&id=71dd13ae&scoped=true&"
import script from "./reportList.vue?vue&type=script&lang=js&"
export * from "./reportList.vue?vue&type=script&lang=js&"
import style0 from "./reportList.vue?vue&type=style&index=0&id=71dd13ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dd13ae",
  null
  
)

export default component.exports